var $html, $body, $wrapper, $header, $content, $footer, $preview, $promo, $hero, $human, $dark, $layout;

var template = '',
    hash = '';

var window_width = 0;
var window_height = 0;

var scroll_y = 0, 
    scroll_down = 0,
    scroll_up = 0,
    scroll_track = 0,
    scroll_direction  = '';

var is_mobile = false,
    is_iframe = false,
    is_preview = false;

var menu_open = false;

var dark          = [],
    dark_content  = [],
    dark_init     = false;


// =LOADED

// $(window).on('load', function() {
// });

// =READY

$(function() {

  $html       = $('html'),
  $body       = $('body'),
  $header     = $('#header'),
  $content    = $('#content'),
  $footer     = $('#footer'),
  $preview    = $('#preview-bar-iframe'),
  $promo      = $('#promo'),
  $hero       = $('#hero'),  
  $human      = $('#human'),  
  $dark       = $('.dark'),
  $layout     = $('main, .layout');

  template  = $html.attr('id').substr(2),
  hash      = document.location.hash.replace('#', ''); 

  // =PREVIEW-DETECTION

  is_preview = $preview.length == 1;
  if (is_preview) {

    $preview.on('load', function() {
      var preview_url = $preview.contents().find('#share_theme_url').val();
      console.log(preview_url);
      $preview.remove();
    });
    
  }

  // =IFRAME-DETECTION

  try {
    is_iframe = window.self !== window.top;
  }
  catch (e) {}

  if (is_iframe) {
    $html.addClass('is_iframe');
  }

  // =MOBILE-DETECTION

  var md = new MobileDetect(navigator.userAgent);  

  is_mobile = !!md.mobile();

  if (is_mobile) {
    $body.addClass('mobile');
  }
  else {
    $body.addClass('not_mobile');
  }

  // =VALIGN

  $.fn.vAlign = function() {

    var $els = $(this);
    if (!$els.hasClass('valign')) {
      $els = $('.valign', this);
    }

    $els.each(function() {

      var $el = $(this);
      var $parent_el = $(this).parent();

      var el_height = $el.outerHeight();
      var parent_el_height = $parent_el.outerHeight();

      var el_top = Math.ceil((parent_el_height - el_height) / 2);
      if (el_top < 0) {
        el_top = 0;
      }

      var p = 'margin-top';
      if ($el.hasClass('valign-top')) {
        p = 'top';
      }

      $el.addClass('ready').addClass('valigned').css(p, el_top);

    });

  };  

  // =WATCH

  $(window).scroll(watch_scroll);

  $(window).resize(watch_resize);

  watch_resize();

  // =COOKIES

  var $cookies = Cookies.noConflict();

  $('.cookie-watch').each(function() {

    var $el = $(this);

    var key_ = $el.data('cookie-key');

    // $cookies.remove(key_);

    var value_ = $cookies.get(key_);

    // console.log([key_, value_, typeof value_]);
    
    if (typeof value_ == 'undefined') {

      $el.css('display', 'block');

      $('button', $el).click(function() {

        $el.css('display', 'none');

        $cookies.set(key_, '1', { expires: 14 });
    
      });

    }

  });

  // =MENU

  $('#menu-link').click(function() {

    $html.toggleClass('menu_open');
    $('.alert').removeClass('on');
    $('#menu .valign').vAlign();
    menu_open = $html.hasClass('menu_open');

  });

  // =CELLS

  $('.cells').each(function() {

    var $cells = $('.cell', this),
        index_ = 1,
        speed_ = 4500;
    
    if ($cells.length > 1) {

    setTimeout(function() {

      setInterval(function() {

        //console.log(speed_);
        
        var $cell_ = $cells.eq(index_ - 1);

        index_++;

        if (index_ > $cells.length) {
          index_ = 1;
        }
        
        $cells.removeClass('last_on');
        $cell_.addClass('last_on');
        
//        $cells.eq(index_ - 1).fadeIn(0);
        //$cells.removeClass('last_on');
        //$('.on', $cells).addClass('last_on').removeClass('on');
        $cells.removeClass('on');//.fadeOut();
        $cells.eq(index_ - 1).fadeOut(0).addClass('on').fadeIn();

      }, speed_);
      
    }, speed_);
      
    }

  });

  // =NEWSLETTER

  $('form.newsletter').each(function() {

    var $el = $(this),
        $email_el = $('input.email', this);
    var email_placeholder = $email_el.attr('placeholder');

    $email_el.focus(function() {

      $email_el.attr('placeholder', 'Enter Your Email');

    });

    $email_el.blur(function() {

      $email_el.attr('placeholder', email_placeholder);

    });

    $('button.close', this).click(function() {

      $email_el.attr('placeholder', email_placeholder);
      $el.removeClass('on error');

    });

    $el.submit(function(e) {

      e.preventDefault();

      var email = $email_el.val().trim(),
          email_re = /\S+@\S+\.\S+/,
          data = $el.serialize(),
          url = $el.attr('action');

      if (email != '' && email_re.test(email)) {

        $email_el.attr('placeholder', 'Subscribing ...').val('');

        $.ajax({
          url       : url,
          data      : data,
          dataType  : 'jsonp',     
          jsonp     : 'c',
          success   : function(d) {
            $el.addClass('on ' + d.result);
          },
          error     : function(d) {
            $el.addClass('on');
          }

        });   

      }
      else {
        $email_el.attr('placeholder', 'Please Enter a Valid Email').val('');
      }

      return false;

    });

  });

  // =PRODUCT

  $('.product').each(function() {

    $('.product__details', this).each(function() {

      var $details = $('div', this);
      var $buttons = $('nav button', this);

      $('div button', this).click(function() {

        $details.removeClass('on');
        $buttons.removeClass('on');

      });

      $buttons.click(function() {
        
        var $button = $(this);
        var index = $button.index();
        var $detail = $details.eq(index);
        var on = $detail.hasClass('on');

        $details.removeClass('on');
        $buttons.removeClass('on');
        if (!on) {
          $detail.addClass('on');
          $button.addClass('on');
        }

      });

    });

  });

  $('form.purchase').each(function() {

    var $el = $(this);
    var $affirm = $('.affirm', this);
    var $price = $('.price', this);
    var $buttons = $('.options button', this);

    $buttons.click(function() {

      var $button = $(this);
      if (!$button.hasClass('on') && !$button.hasClass('sold')) {

        $buttons.removeClass('on');
        $button.addClass('on');

        var id = $button.data('id');        
        $('input[name="id"]', $el).val(id);

        var price = $button.data('compare-price');
        if (price != '') {
          price = ' <span>' + price + '</span>';
        }
        price = $button.data('price') + price;
        $price.html(price);

        var affirm_price = $button.data('affirm-price')
        $affirm.get(0).setAttribute('data-amount', affirm_price);
        affirm.ui.refresh();


      }

    });

  });

  // =CART

  var $cart_link  = $('#cart-link'),
      $cart_alert = $('#cart-alert'),
      $cart_count = $('#cart-count');

  var cart_alert_timer;

  $('.add-to-cart').click(function(e) {

    e.preventDefault();

    var $el = $(this);
    var $form_el = $el.parent('form');
    
    $('span', $el).text('Adding to Cart ...');

    $.post({
      url      : '/cart/add.js',
      dataType : 'json', 
      data     : $form_el.serialize(),
      success  : function() {

        $promo.removeClass('on');
        $cart_alert.addClass('on');

        // $('span', $el).delay(1000).text('Added!');      

        clearTimeout(cart_alert_timer);
        cart_alert_timer = setTimeout(function() {

          $cart_alert.removeClass('on');
          $('span', $el).delay(2000).text('Add to cart');            

          $promo.addClass('on');

        }, 1500);
        
      },
      error    : function() {}
    });   

    var cart_count = parseInt( $cart_count.text() );
    if (isNaN(cart_count)) {
      cart_count = 0;
    }
    cart_count++;

    update_cart_count(cart_count);

  });

  function update_cart_count(cart_count) {

    var add_class     = 'empty',
        remove_class  = 'not-empty',
        cart_text     = cart_count.toString();

    if (cart_count != '0') {
      add_class     = 'not-empty';
      remove_class  = 'empty';
    }

    $cart_count.text(cart_text);

    $cart_link.removeClass(remove_class).addClass(add_class).addClass('animate').one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
      $(this).removeClass('animate');
    });    

  } 

  // =RESIZE

  function watch_resize() {

    window_width = $.windowWidth();
    window_height = $.windowHeight();

    // if ($hero.length != 0) {

    //   offset_ = $human.height() + (parseInt($human.css('bottom')) * 2)
    //   height_ = window_height - offset_;
    //   $hero.css('height', height_);

    // }

    $('.valign').vAlign();

    watch_scroll();

    watch_dark();

  }

  // =WATCH-DARK

  function watch_dark() {

    // determine bounderies of containers with dark backgrounds
    // might want to move this to watch_resize for performance vs. accuracy

    var i = 0;

    // console.clear();

    dark         = [],
    dark_content = [];

    $dark.each(function() {

      var $el = $(this);
      var $parent_el = $el.parent();

      var content_  = $el.hasClass('dark-content'),
          height_   = $el.outerHeight();

      var top_    = $el.position().top;
      if (!content_) {

        top_ = parseInt($parent_el.css('top'));

        offset_ = parseInt($el.css('margin-top'));
        if (!isNaN(offset_)) {
          top_ += offset_;
        }

      }

      var bottom_ = (top_ + height_);
      // if (!content_) {

      //   offset_ = parseInt($el.css('margin-bottom'));
      //   if (!isNaN(offset_)) {
      //     bottom_ += offset_;
      //   }

      // }

      var dark_ = { 'content': content_, 'top' : top_, 'height': height_, 'bottom': bottom_, 'el': $el };

      if (content_) {
        dark_content.push(dark_);
      }
      else {
        dark.push(dark_);
      }

      // console.log(dark_);      

    });

    // console.clear();
    // console.log(['scroll_y', scroll_y]);

    // clip based on boundaries

    $.each(dark, function(dark_k_, dark_) {

      var clipped_ = false;

      // console.log(dark_);                

      $.each(dark_content, function(dark_content_k_, dark_content_) {

        if (dark_content_.el.css('display') != 'none' && !clipped_) {

          // console.log('\t', dark_content_);

          var $dark_el = dark_.el,
              dark_clip = 'none';

          var $light_el = $dark_el.siblings('.light').eq(0),
              light_clip = 'inset(100% 0 0 0)';

          var top_ = dark_content_.bottom - scroll_y;
          var bottom_ = dark_.bottom + scroll_y - dark_content_.top;

          // console.log('\t\t', { 'top' : top_, 'bottom': bottom_ });

          if (bottom_ > 0) {

            var clip_ = top_ - dark_.top;

            if (bottom_ < dark_content_.height) {

              clip_ = dark_.height - bottom_;
              dark_clip = 'inset(0 0 ' + (dark_.height - clip_) + 'px 0)';
              light_clip = 'inset(' + clip_ + 'px 0 0 0)';
              clipped_ = true;              

            }
            else if (top_ < dark_.bottom && clip_ > 0) {

              dark_clip = 'inset(' + clip_ + 'px 0 0 0)';
              light_clip = 'inset(0 0 ' + (dark_.height - clip_) + 'px 0)';
              clipped_ = true;

            }            

          }

          $dark_el.css({ 'clip-path': dark_clip, '-webkit-clip-path': dark_clip });
          $light_el.css({ 'clip-path': light_clip, '-webkit-clip-path': light_clip });        

          // console.log(dark_clip);
          // console.log(light_clip);

        }

      });

    });

    if (!dark_init) {

      dark_init = true;

      setTimeout(function() {

        watch_dark();
        $('.valign').vAlign();

        if (template == 'index') {
          $layout.fadeOut(0).css('visibility', 'visible').fadeIn(1000);
        }

      }, 500);

    }

  }

  // =SCROLL

  function watch_scroll() {

    if (menu_open) {
      $(window).scrollTop(scroll_y);
    }

    var scroll_init = scroll_direction != '';
    var scroll_y_ = $(window).scrollTop();
    
    scroll_direction = 'down';
    if (scroll_y >= scroll_y_) {
      scroll_direction = 'up';
      scroll_down = 0;
      scroll_up += (scroll_y - scroll_y_);
    }

    if (scroll_init && scroll_direction == 'down') {
      scroll_down += (scroll_y_ - scroll_y);
      scroll_up = 0;
    }

    scroll_y = scroll_y_;
    scroll_offset = (window_height / 2);

    watch_dark();

    if (!menu_open) {

      if (scroll_direction == 'up') {
        if (scroll_up > scroll_offset) {
          $promo.addClass('on');
        } 
      }
      else if (scroll_down > scroll_offset) {
        $promo.removeClass('on');
      }

    }

  }

  // =ESCAPE

  $(document).on('keyup',function(e) {

    if (e.keyCode == 27) {
      if (menu_open) {
        $('#menu-link').click();
      }
    }

  });

  // var gtag_track = function(url, category, label) {

  //   gtag('event', 'click', {
  //     'event_category': category,
  //     'event_label': label,
  //     'transport_type': 'beacon',
  //     'event_callback': function(){ document.location = url; }
  //   });

  //   setTimeout(function(){ document.location = url; }, 1000);

  // }  

});
